module.exports = __webpack_public_path__ + "static/media/Guitar-2.22beb71b.jpg";